import React, { useState } from 'react';
import { endpointUploadReportOptimized, urlTasks } from '../services/Endpoints';
import Button from 'react-bootstrap/esm/Button';

const FileUploaderReport = ({ channel, onClose, onUploadSuccess }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [dragging, setDragging] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [labelButton, setLabelButton] = useState('Subir archivo');
    const [appendToReport, setAppendToReport] = useState(false);

    const handleDragOver = (e) => {
        e.preventDefault();
        setDragging(true);
    };

    const handleDragEnter = (e) => {
        e.preventDefault();
        setDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragging(false);
        const file = e.dataTransfer.files[0];
        setSelectedFile(file);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setSelectedFile(file);
    };

    const handleUpload = async () => {
        if (selectedFile) {
            const formData = new FormData();
            formData.append('file', selectedFile);
            formData.append('channel', channel);
            formData.append('append_to_report', appendToReport);

            setUploading(true);
            setLabelButton('Cargando...');

            try {
                // Usar endpoint optimizado
                const response = await fetch(`${urlTasks}${endpointUploadReportOptimized}`, {
                    method: 'POST',
                    body: formData
                });

                const res = await response.json();
                if (res && res.status === 'success') {
                    const data = res.data;
                    let message = 'Se ha iniciado el proceso de carga de reportes. Dependiendo del tamaño puede demorar unos minutos.';
                    // let message = `Reporte cargado correctamente!\n`;
                    // message += `- Registros: ${data.records_loaded}\n`;
                    // message += `- Tiempo: ${data.load_time}s\n\n`;
                    // message += `Usa el botón "Sincronizar" para actualizar los estados en Inkit.`;

                    alert(message);
                    setSelectedFile(null);
                    if (onUploadSuccess) {
                        onUploadSuccess();
                    }
                    if (onClose) {
                        onClose();
                    }
                } else {
                    alert('Error al cargar el archivo: ' + (res.message || 'Error desconocido'));
                }
            } catch (error) {
                alert('Error al cargar el archivo: ' + error.message);
            }

            setUploading(false);
            setLabelButton('Subir archivo');

        } else {
            alert('Por favor, seleccione un archivo.');
        }
    };

    const handleDelete = () => {
        setSelectedFile(null);
    };

    return (
        <div>
            <label
                onDragOver={handleDragOver}
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                htmlFor="fileInputReport"
                style={{
                    border: `2px dashed ${dragging ? 'blue' : 'black'}`,
                    padding: '60px',
                    marginBottom: '20px',
                    display: 'block',
                    cursor: 'pointer',
                    textAlign: 'center'
                }}
            >
                Arrastra y suelta el archivo aquí, o haz clic para seleccionar uno.
                <input
                    type="file"
                    id="fileInputReport"
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                    accept=".xlsx,.xls,.csv,.txt"
                />
            </label>
            <div className='d-flex justify-content-center'>
                <Button variant="primary" onClick={handleUpload} disabled={uploading || !selectedFile}>
                    {labelButton}
                </Button>
            </div>

            <div className="d-flex justify-content-center mt-3">
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckAppend"
                        checked={appendToReport}
                        onChange={(e) => setAppendToReport(e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="flexCheckAppend">
                        Cargar como parte de un reporte existente (no borrar anterior)
                    </label>
                </div>
            </div>

            {selectedFile && (
                <div className="mt-3">
                    <strong>Archivo Seleccionado:</strong> {selectedFile.name}
                    <div>
                        <a href="javascript:void()" onClick={handleDelete} className='action'>Eliminar selección</a>
                    </div>
                </div>
            )}
        </div>
    );
};

export default FileUploaderReport;
